import { Permission } from '@server/permissions';
import { usePermissions } from './usePermissions';

const useCheckAccountPermissions = (permissionArray: Permission[]) => {
  const { checkAccountPermissions } = usePermissions();

  return checkAccountPermissions(permissionArray);
};

export default useCheckAccountPermissions;
